<div>
  <div class="modal-header">
    <h4 class="modal-title">Clone - {{ voiceName }} </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.close(true)"></button>
  </div>
  <div class="modal-body">
      <app-voice-form 
        action="clone"
        [voice]="visibleVoice"
        (formValidityChangeEvent)="onValidityChange($event)">
      </app-voice-form>
  </div>
  <div class="modal-footer">
      <button type="submit" [disabled]="isInvalid" class="btn btn-raised btn-success" (click)="submit()">
          <span> Save
              <i *ngIf="(cloning$ | async) as cloning" class="fa fa-refresh refreshbtn" matSuffix
                  [ngClass]="{'fa-spin': cloning }">
              </i>
          </span>
      </button>
      <button type="button" class="btn btn-raised btn-secondary me-2" (click)="modal.close(true)">
          Close
      </button>
  </div>
</div>
